module.exports = __webpack_public_path__ + "img/四川天府新区正兴中学.9f91e080.jpg";